import React, { useEffect, useRef } from 'react';

const RichTextEditor = ({ value, onChange }) => {
  const editorRef = useRef(null);

  useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== value) {
      editorRef.current.innerHTML = value || '';
    }
  }, [value]);

  const runCommand = (command, commandValue = null) => {
    editorRef.current?.focus();
    document.execCommand(command, false, commandValue);
    onChange(editorRef.current?.innerHTML || '');
  };

  const toolbarButton = (label, command, commandValue = null) => (
    <button
      type="button"
      title={label}
      aria-label={label}
      onMouseDown={(event) => event.preventDefault()}
      onClick={() => runCommand(command, commandValue)}
    >
      {label}
    </button>
  );

  return (
    <div className="rich-editor">
      <div className="rich-editor-toolbar" aria-label="Text formatting toolbar">
        {toolbarButton('Paragraph', 'formatBlock', 'p')}
        {toolbarButton('Heading', 'formatBlock', 'h3')}
        {toolbarButton('Bold', 'bold')}
        {toolbarButton('Italic', 'italic')}
        {toolbarButton('Underline', 'underline')}
        {toolbarButton('Bullets', 'insertUnorderedList')}
        {toolbarButton('Numbered list', 'insertOrderedList')}
        {toolbarButton('Undo', 'undo')}
        {toolbarButton('Redo', 'redo')}
      </div>
      <div
        ref={editorRef}
        className="rich-editor-content"
        contentEditable
        suppressContentEditableWarning
        onInput={(event) => onChange(event.currentTarget.innerHTML)}
        data-placeholder="Enter the full description, quotation, specifications, and included items..."
      />
    </div>
  );
};

export default RichTextEditor;
